// client/src/components/ui/CurrencyLogos.jsx
// Logos SVG temporaires pour les monnaies — pieces (or), ORIN (violet), ORI (turquoise).
import React from 'react';

export const CoinLogo = ({ size = 16, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="coin-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#ffe9a8" />
        <stop offset="0.5" stopColor="#ffd166" />
        <stop offset="1" stopColor="#d99a1f" />
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="10" fill="url(#coin-g)" stroke="#8a5f0a" strokeWidth="1.4" />
    <circle cx="12" cy="12" r="6.6" fill="none" stroke="#8a5f0a" strokeWidth="1" opacity="0.55" />
    <path d="M10.2 7.5h3.6M12 7.5v9M9.6 16.5h4.8" stroke="#8a5f0a" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const OrinLogo = ({ size = 16, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="orin-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#e3d0ff" />
        <stop offset="0.5" stopColor="#a06bff" />
        <stop offset="1" stopColor="#6a2fd4" />
      </linearGradient>
    </defs>
    <path d="M12 2.2 21 8v8l-9 5.8L3 16V8z" fill="url(#orin-g)" stroke="#3c1a85" strokeWidth="1.3" />
    <path d="M12 6.4 17 9.4v5.2L12 17.6 7 14.6V9.4z" fill="none" stroke="#e9dcff" strokeWidth="1.1" opacity="0.85" />
    <circle cx="12" cy="12" r="1.9" fill="#f2e8ff" />
  </svg>
);

export const OriLogo = ({ size = 16, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="ori-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#b8fff0" />
        <stop offset="0.5" stopColor="#2fe0c0" />
        <stop offset="1" stopColor="#0b8a76" />
      </linearGradient>
    </defs>
    <path d="M12 1.8 22.2 12 12 22.2 1.8 12z" fill="url(#ori-g)" stroke="#075a4d" strokeWidth="1.3" />
    <path d="M12 5.6 18.4 12 12 18.4 5.6 12z" fill="none" stroke="#d8fff7" strokeWidth="1.1" opacity="0.85" />
    <path d="M9 12h6M12 9v6" stroke="#d8fff7" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);
